/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceOnboardingStep } from './SurfaceOnboardingStep';
import {
    SurfaceOnboardingStepFromJSON,
    SurfaceOnboardingStepFromJSONTyped,
    SurfaceOnboardingStepToJSON,
    SurfaceOnboardingStepToJSONTyped,
} from './SurfaceOnboardingStep';

/**
 * 
 * @export
 * @interface SurfaceOnboardingConfig
 */
export interface SurfaceOnboardingConfig {
    /**
     * Header text (e.g. "How to Play")
     * @type {string}
     * @memberof SurfaceOnboardingConfig
     */
    title?: string;
    /**
     * 
     * @type {Array<SurfaceOnboardingStep>}
     * @memberof SurfaceOnboardingConfig
     */
    steps?: Array<SurfaceOnboardingStep>;
    /**
     * Whether users can dismiss (persists via localStorage). Default true.
     * @type {boolean}
     * @memberof SurfaceOnboardingConfig
     */
    dismissible?: boolean;
}

/**
 * Check if a given object implements the SurfaceOnboardingConfig interface.
 */
export function instanceOfSurfaceOnboardingConfig(value: object): value is SurfaceOnboardingConfig {
    return true;
}

export function SurfaceOnboardingConfigFromJSON(json: any): SurfaceOnboardingConfig {
    return SurfaceOnboardingConfigFromJSONTyped(json, false);
}

export function SurfaceOnboardingConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceOnboardingConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'steps': json['steps'] == null ? undefined : ((json['steps'] as Array<any>).map(SurfaceOnboardingStepFromJSON)),
        'dismissible': json['dismissible'] == null ? undefined : json['dismissible'],
    };
}

export function SurfaceOnboardingConfigToJSON(json: any): SurfaceOnboardingConfig {
    return SurfaceOnboardingConfigToJSONTyped(json, false);
}

export function SurfaceOnboardingConfigToJSONTyped(value?: SurfaceOnboardingConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'steps': value['steps'] == null ? undefined : ((value['steps'] as Array<any>).map(SurfaceOnboardingStepToJSON)),
        'dismissible': value['dismissible'],
    };
}

